import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Chat } from './Chat';
import { SeloChat, SeloNaoLidas } from './dados';
import { CanalEmBreve } from '../../componentes/canal-em-breve';
import { i18n } from './i18n';

/** Fase 2, W15: módulo Equipe (chat da equipe) no menu Comunicação, com o selo de não lidas no item do menu. */
const modulo: ModuloWeb = {
  slug: 'equipe',
  menu: 'comunicacao',
  ordem: 10,
  abas: [{ chave: 'chat', posicao: 10, selo: SeloChat, permissao: 'equipe.ver', componente: Chat }],
  // Comunicação unificada: Telegram e Slack, ainda sem conector.
  rotasExtras: [{ caminho: 'em-breve/:canal', componente: CanalEmBreve }],
  seloMenu: SeloNaoLidas,
  i18n,
};

export default modulo;
